import { render, staticRenderFns } from "./ProcessDefinitionBPMN.vue?vue&type=template&id=cd2e41fa&scoped=true&"
import script from "./ProcessDefinitionBPMN.vue?vue&type=script&lang=js&"
export * from "./ProcessDefinitionBPMN.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDefinitionBPMN.vue?vue&type=style&index=0&id=cd2e41fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2e41fa",
  null
  
)

export default component.exports